import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-cabinet-unit-heater-cabinet-features',
    templateUrl: './cabinet-unit-heater-cabinet-features.component.html',
    styleUrls: ['./cabinet-unit-heater-cabinet-features.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class CabinetUnitHeaterCabinetFeaturesComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  drainPanSelection!: GuruEntity;
  outsideAirWallBoxSelection!: GuruEntity;
  pipingControlsSelection!: GuruEntity;
  tamperProofPanelSelection!: GuruEntity;
  trimKitSelection!: GuruEntity;
  levelingLegsSelection!: GuruEntity;
  cabinetMaterialSelection!: GuruEntity;
  cabinetInsulationSelection!: GuruEntity;
  frontPanelSelection!: GuruEntity;
  leftExtensionSelection!: GuruEntity;
  rightExtensionSelection!: GuruEntity;
  extensionDepthSelection!: GuruEntity;
  extensionHeightSelection!: GuruEntity;
  insulatedRearExtension!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CABINET_FEATURES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.outsideAirWallBoxSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWallBox');
    this.pipingControlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSameSidePipeControls');
    this.tamperProofPanelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTamperProofPanel');
    this.trimKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTrimKit');
    this.levelingLegsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USLevelLegs');
    this.cabinetMaterialSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USGSChassis');
    this.cabinetInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetInsulation');
    this.frontPanelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRetBlkOff');
    this.leftExtensionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtLeft');
    this.rightExtensionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtRight');
    this.extensionDepthSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtDepth');
    this.extensionHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtHeight');
    this.insulatedRearExtension = SelectionUtils.getEntity(this.selectionEntities(), 'USInsulatedAOR');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
